import { FC } from 'react'

import { ISvgClass } from '../interface'

const OnlypayLogoCompleteNewIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 2048 973"
      width="180"
      height="90"
      {...props}
    >
      <path
        transform="translate(456,120)"
        d="m0 0h50l28 3 28 5 30 8 23 8 23 10 16 8 15 8 19 12 18 13 11 9 14 12 17 16 7 8 11 12 13 17 10 14 13 21 12 23 8 17 9 24 6 19 7 29 4 26 2 22v45l-3 30-6 31-6 23-9 26-10 23-11 22-14 23-12 17-13 16-9 11-29 29-11 9-15 12-20 14-26 15-22 11-25 10-24 8-28 7-31 5-22 2h-45l-30-3-28-5-30-8-26-9-27-12-21-11-21-13-18-13-16-13-10-9-8-7-17-17-9-11-11-13-13-18-13-21-14-27-9-20-10-28-7-26-5-27-3-25-1-17v-27l2-28 4-26 6-27 9-29 11-27 8-17 10-18 12-19 14-19 9-11 12-14 22-22 8-7 17-14 20-14 21-13 27-14 26-11 27-9 28-7 30-5zm1 34-27 3-26 5-25 7-20 7-23 10-23 12-19 12-14 10-14 11-12 11-8 7-12 12-7 8-14 17-14 20-14 24-13 27-9 24-7 24-6 29-3 25-1 21v18l2 26 4 26 6 25 7 23 9 22 12 25 10 17 13 19 10 13 12 14 14 15 16 15 14 11 13 10 17 11 16 9 17 9 19 8 22 8 30 8 29 5 21 2h44l28-3 31-6 27-8 19-7 20-9 23-12 19-12 19-14 14-12 12-11 16-16 9-11 10-12 14-20 15-26 11-23 10-27 7-25 5-24 3-23 1-13v-37l-3-30-6-31-7-24-8-22-11-24-12-22-14-21-13-17-13-15-24-24-11-9-14-11-24-16-18-10-16-8-24-10-24-8-30-7-27-4-12-1z"
        fill="#2221BC"
      />
      <path
        transform="translate(335,339)"
        d="m0 0h31l20 3 19 5 15 6 19 10 11 8 13 11 7 7 11 14 9 15 7 15 6 19 3 18v33l-3 18-5 16-7 17-11 18-11 13-12 12-16 12-18 10-21 8-21 5-16 2h-29l-21-3-22-6-18-8-16-9-13-10-12-11-11-13-9-14-8-16-5-13-5-22-1-9v-27l3-19 6-20 11-23 10-14 12-14 10-9 14-10 16-9 19-8 19-5zm2 56-14 3-13 5-12 7-10 8-9 9-10 15-6 15-3 11-1 8v18l3 17 5 13 7 13 8 10 11 11 14 9 16 7 13 3 9 1h12l18-3 16-6 13-8 13-11 9-11 8-14 5-13 3-14v-23l-4-18-7-16-10-14-13-13-14-9-14-6-17-4z"
        fill="#2221BC"
      />
      <path
        transform="translate(503,340)"
        d="m0 0h85v235h22v56h-85l-1-235-21-1z"
        fill="#0ff"
      />
      <path
        transform="translate(612,340)"
        d="m0 0h49l21 3 21 6 16 8 11 7 13 13 9 14 6 15 3 15v29l-4 18-5 12-6 10-11 13-12 9-10 6-15 6-14 4-20 3h-52v-52l42-1 15-3 10-5 6-5 6-10 3-10v-18l-4-13-7-9-10-7-13-4-6-1-42-1z"
        fill="#2221BC"
      />
      <path
        transform="translate(1731,513)"
        d="m0 0h21l13 38 11 34 2-3 21-68h26l-3 10-19 57-14 41-1 3h-22l-4-10-11-31-10-29-22 64-3 6h-21l-5-12-18-54-14-41-1-4h27l18 59 4 13 14-41z"
        fill="#2221BC"
      />
      <path
        transform="translate(1053,327)"
        d="m0 0h12l12 2 15 6 10 7 8 7 9 13 5 11 3 12v21l-4 15-7 13-10 12-11 8-12 6-11 3-8 1h-13l-15-3-16-8-10-8-9-11-7-14-3-13v-22l4-15 7-13 9-11 10-8 14-7 11-3zm-1 21-12 3-10 5-10 9-7 11-4 13v17l4 13 6 10 10 10 14 7 8 2h16l13-4 10-6 9-9 6-10 3-9 1-5v-13l-3-12-6-11-9-10-10-6-11-4-6-1z"
        fill="#2221BC"
      />
      <path
        transform="translate(1443,514)"
        d="m0 0h83v22h-59v22h52v22h-52v23h60v22h-84z"
        fill="#2221BC"
      />
      <path
        transform="translate(1270,333)"
        d="m0 0 4 2 9 10 23 23 7 8 19 19 7 8 17 17 1-86h18v129l-7-6-23-23-7-8-19-19-7-8-24-24v87h-18z"
        fill="#2221BC"
      />
      <path
        transform="translate(995,514)"
        d="m0 0h28l18 49 9 24v3h2l3-10 15-41 9-24 1-1h26l-3 10-15 37-25 62-1 2h-22l-4-8-40-100z"
        fill="#2221BC"
      />
      <path
        transform="translate(1712,334)"
        d="m0 0h19l12 19 14 23 10 16v2h2l2-5 14-23 13-21 7-11h20l-2 5-14 22-12 19-15 24-4 6-1 52h-18l-1-52-24-38-15-24-7-11z"
        fill="#2221BC"
      />
      <path
        transform="translate(1528,334)"
        d="m0 0h18v113h57v15h-75z"
        fill="#2221BC"
      />
      <path
        transform="translate(1252,514)"
        d="m0 0h25v110l-1 1h-23l-1-1z"
        fill="#2221BC"
      />
    </svg>
  )
}

export default OnlypayLogoCompleteNewIcon
